export default {
  saveTabsForDownload(state, tabs) {
    state.savedTabsForDownload = [...tabs];
  },
};
